<template>
  <div>
    <h5 class="info-text">Step 2: Please review the guidance then click Next</h5>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="md-layout">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-radio v-model="model.accept" :value="false">Accept</md-radio>
            <md-radio v-model="model.accept" :value="true">Reject</md-radio>
          </div>

          <md-field>
            <md-input v-model="model.code" type="text"></md-input>
            <span class="md-helper-text"
            >If rejected please provide reason</span>
          </md-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {

    data () {
        return {
            model: {
                reject: false,
                accept: true,
                develop: false
            }
        };
    },
    methods: {
        validate () {
            this.$emit('on-validated', true, this.model);
            return Promise.resolve(true);
        }
    }
};
</script>
<style></style>
